exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".participatingStudentsDisplay{font-size:.8em}.participatingStudentsDisplay .studentAvatarWrap{display:inline-block}.participatingStudentsDisplay .moreStudentsContainer{display:inline-block;white-space:nowrap;position:relative;top:5px}.participatingStudentsDisplay .allStudentsDisplay img{height:25px;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/participating_students_display.scss
// module id = 1361
// module chunks = 0